import React from "react";

import HelpTooltip from "@/components/ui/HelpTooltip";

interface SettingsSectionProps {
  title: string;
  children: React.ReactNode;
  info?: string;
}

const SettingsSection: React.FC<SettingsSectionProps> = ({ title, children, info }) => (
  <div className="relative w-full space-y-1.5">
    <div className="flex flex-row items-center">
      <h3 className="text-sm font-medium text-gray-700">{title}</h3>
      {info && <HelpTooltip content={info} />}
    </div>
    {children}
  </div>
);

export default SettingsSection;
